
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiStandbyIec as ObiStandbyIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-standby-iec.js';
 
 
 

 
 export const ObiStandbyIec = createComponent({
   react: React,
   tagName: 'obi-standby-iec',
   elementClass: ObiStandbyIecElement,
   events: {
     
   }
  });
 
 